import { DeliveryNoteParams } from '../../models';

export class DeliveryNoteTrackingLoad {
  public static readonly type = '[DeliveryNoteOverview] Load Tracking';
  constructor(public payload: DeliveryNoteParams) {}
}

export class DeliveryNoteOverviewLoad {
  public static readonly type = '[DeliveryNoteOverview] Load Overview';
  constructor(public payload: DeliveryNoteParams) {}
}

export class DeliveryNoteOverviewInitialState {
  public static readonly type = '[DeliveryNoteOverview] Set Initial State';
}
